import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { globalDeleteService, globalGetService, globalPostService } from "../../../../utils/globalApiServices";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import SettingNav from "../../../elements/SettingNav";
import AccountTypeList from "../components/AccountTypeList";
import AccountTypeCRU from "../components/AccountTypeCRU";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { checkApiStatus } from "../../../../utils";
import { deleteAccountTypeApi, getAccountTypeListApi, restoreAccountTypeApi } from "../apiService";
import { LeasesMenuList } from "../../../elements";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { ButtonLoader } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const AccountTypeHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const isNotDeleted= item?.filter(optionItem=>optionItem?.is_deleted===false)
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Rate Account Types`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', isNotDeleted)} checked={isNotDeleted?.length === bulk?.ids?.length && isNotDeleted?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{minWidth: '150px'}}> {tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{minWidth: '200px'}}> {tableSorting('applicable_for', 'Applicable for')}</TableCell>
                <TableCell sx={{minWidth: '100px'}}> {tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{minWidth: '200px'}}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const AccountType = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [accountTypeInfo, setAccountTypeInfo] = useState({ list: [], pagination: {} });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [accountTypeCRU, setAccountTypeCRU] = useState({ modal: false, data: null, mode: '' });
    const [deletAccountType, setDeleteAccountType] = useState({ modal: false, data: null, })
    const [restoreAccountType, setRestoreAccountType] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const[isExport,seIsExport]=useState(false)


    useEffect(() => {
        getAccountTypeList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Rate Account Types'})
    }, [])

    const toggleBulkOps = (flag, type, item) => {
            if (type === 'bulk') {
                setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getAccountTypeList('pageLoader', { ...sortQuery, per_page: accountTypeInfo?.pagination?.per_page });
    }

    const getAccountTypeList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getAccountTypeListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setAccountTypeInfo(response.data.data);
            }
        })

    }

    const deleteAccountType = () => {
        setLoading(true);
        const idsToDelete = deletAccountType?.modal && deletAccountType?.data?.id ? [deletAccountType?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteAccountTypeApi(), { ids: idsToDelete} )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Rate Account Types`, success_msg: response?.data?.message, item_ids: deletAccountType?.data || bulk?.ids, response: response?.data })
                    setDeleteAccountType({ modal: false, data: null });
                    getAccountTypeList('', { per_page: accountTypeInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], title: '', type: '' });
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Rate Account Types`, error_msg: response?.data?.message, item_ids: deletAccountType?.data || bulk?.ids, response: response?.data })
                }
            })
    }
    const onRestoreAccountType=()=>{
        const selectedItemName = restoreAccountType?.data?.name?.trim();
        const hasDuplicateName = accountTypeInfo?.list?.some((item) =>
            item?.id !== restoreAccountType?.data?.id &&
            item?.name?.trim() === selectedItemName
        );

        if (hasDuplicateName) {
            enqueueSnackbar('Rate Account Type with the same name already exists.', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            setRestoreAccountType({ modal: false, data: null });
            return;
        }

        setLoading(true);
        globalPostService(restoreAccountTypeApi(), { ids: [restoreAccountType?.data?.id] }).then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Restored', { page_title: `Restore Rate Account Types`, success_msg: response?.data?.message, item_ids: deletAccountType?.data || bulk?.ids, response: response?.data })
                    setRestoreAccountType({ modal: false, data: null })
                    getAccountTypeList('', { per_page: accountTypeInfo?.pagination?.per_page });
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Restore', { page_title: `Restore Rate Account Types`, error_msg: response?.data?.message, item_ids: deletAccountType?.data || bulk?.ids, response: response?.data })
                }
            })

    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getAccountTypeListApi(query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Rate Account Types`, page_type: page_type, })
    }

    return (
        <Paper className="setting_details_section lease-details-section lease-module-paper" elevation={0}>
            <SettingNav />
            <div className="lease-details-content" >
                <Paper square className="responsive-paper">
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                        <Grid item size={{ md: 8, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px 0px' }}>
                                <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} /> </li>
                                {
                                    bulk?.type && bulk?.ids?.length ?
                                        <>
                                            <li className='lease-mobile-button'>
                                                <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                            </li>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['D'] }}>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                        </> : null
                                }
                                {accountTypeInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button className='btn-primary action-btn-start-icon' startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "rate_account_type", operationType: ['C'] }}>
                                    <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setAccountTypeCRU({ modal: true, data: { status: true }, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add Rate Account Type </Button> </li>
                                </PermissionWrapper>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper
                    className="lease-detail-table table-container lease-module-paper"
                    elevation={0}
                    sx={accountTypeInfo?.list?.length > 0
                        ? { display: 'flex', flexDirection: 'column', height: 'calc(100vh - 138px) !important', maxHeight: 'calc(100vh - 138px)' }
                        : { display: 'flex', flexDirection: 'column', height: 'auto !important', maxHeight: 'calc(100vh - 138px)' }}
                >
                    <div style={{ flex: accountTypeInfo?.list?.length > 0 ? '1 1 auto' : '0 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <AccountTypeHd
                                    item={accountTypeInfo?.list}
                                    bulk={bulk}
                                    toggleBulkOps={toggleBulkOps}
                                    sortInfo={sortInfo}
                                    createSortHandler={createSortHandler} />
                                <TableBody>
                                    {accountTypeInfo?.list?.length > 0 && accountTypeInfo?.list?.map((item, index) =>
                                        <AccountTypeList
                                            key={index}
                                            item={item}
                                            bulk={bulk}
                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                            onEditFn={() => setAccountTypeCRU({ modal: true, data: item, mode: 'edit' })}
                                            onView={() => setAccountTypeCRU({ modal: true, data: item, mode: 'view' })}
                                            ondeleteAccountType={() => {
                                                setDeleteAccountType({ modal: true, data: item, });
                                                setBulk({ modal: false, ids: [item], title: '', type: '' });
                                            }}
                                            onRestore={()=>setRestoreAccountType({ modal: true, data: item })}
                                            toggleBulkOps={toggleBulkOps}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && accountTypeInfo?.list?.length === 0 && <NoRecordFound />}
                    </div>
                    <Paper square>
                    <Pagination
                        pagination={accountTypeInfo?.pagination}
                        onPageChange={(event, newPage) => { const pageNum = newPage + 1; getAccountTypeList("pageLoader", { page: pageNum, per_page: accountTypeInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getAccountTypeList("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                    />
                    </Paper>
                </Paper>
            </div>
            {accountTypeCRU.modal &&
                <AccountTypeCRU
                    accountTypeCRU={accountTypeCRU}
                    modeType={accountTypeCRU?.mode}
                    getResponseBack={() => {getAccountTypeList("", { per_page: accountTypeInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], title: '', type: ''}); }}
                    onToggleModal={() => setAccountTypeCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deletAccountType.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal :  deletAccountType.modal}
                    title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (accountTypeInfo?.list?.length || 0)) ? 'Delete All Rate Account Types' : 'Delete Selected Rate Account Types' : 'Delete Rate Account Type'}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} records?` : `Are you sure, you want to Delete?`}
                    // onToggleModal={ () => bulk.modal ? setBulk({ modal: false, ids: [] }) :setDeleteAccountType({ modal: false, data: null })}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : (setDeleteAccountType({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' })) }
                    onDeleteRecords={() => deleteAccountType()}
                /> : null}
            {restoreAccountType?.modal ?
                <DeletePopUp
                    modal={restoreAccountType?.modal}
                    title='Restore Rate Account Type'
                    content='Are you sure, you want to Restore this?'
                    onToggleModal={() => setRestoreAccountType({ modal: false, data: null })}
                    onDeleteRecords={() => onRestoreAccountType()}
                    confirmColor='primary'
                    confirmText='Restore'
                />
                : null}
             { revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"rate_account_types"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            }

            {isLoading ? <PageLoader /> : null}
        </Paper>
    )

};
export default RoleBaseAccess(AccountType, { application: 'lease_revamp', feature: 'rate_account_type', operationType: ['R'] });
